import React, { useRef } from 'react'
import { ReactComponent as Cross } from '../../assets/icons/cross.svg'
import Button from '../Button/Button'
import CookieModalField from './CookieModalField'
import { Color } from '../../utils/constants'
import ScrollBar from '../ScrollBar'
import { Link } from '../../utils/helpers'

const data = [
    {
        id: 'necessary',
        text: 'These cookies enable core functionality such as security, verification of identity and network management. These cookies can’t be disabled.',
    },
    {
        id: 'marketing',
        text: 'These cookies are used to track advertising effectiveness to provide a more relevant service and deliver better ads to suit your interests.',
    },
    {
        id: 'statistics',
        text: 'These cookies allow our website to improve functionality by analyzing website traffic.',
    },
    // {
    //     id: 'analytics',
    //     text: 'These cookies help us to understand how visitors interact with our website, discover errors and provide a better overall analytics.',
    // },
]

interface CookieModalProps {
  onClose: () => void
  cookieForm: Record<string, { on: boolean; editable: boolean }>
  setCookieForm: (form: Record<string, { on: boolean; editable: boolean }>) => void
  submit: () => void
}

const CookieModal = ({ onClose, cookieForm, setCookieForm, submit }: CookieModalProps) => {
    const ref = useRef<HTMLDivElement>(null)
    return (
        <div className='max-w-[856px] h-[580px] bg-white relative'>
            <Button
                outerClasses='absolute right-0 top-0 m-3 md:m-6 border-black/20 z-50'
                innerClasses='p-4'
                onClick={onClose}
            >
                <Cross className='w-3.5 h-3.5' />
            </Button>
            <div className='py-10 px-6 md:px-10 h-full'>
                <div className='relative h-full'>
                    <h4>Advanced Cookie Settings</h4>
                    <h5 className='text-black/40 pb-6'>
            Read more about our Privacy Policy{' '}
                        <Link to='/privacy' className='underline' onClick={onClose}>
              here
                        </Link>
                    </h5>
                    <div className='relative h-full flex flex-col'>
                        <div className='overflow-y-scroll no-scrollbar pb-44' ref={ref}>
                            {data.map(({ id, text }, index) => (
                                <CookieModalField
                                    text={text}
                                    id={id}
                                    isLast={index === data.length - 1}
                                    key={id}
                                    cookieForm={cookieForm}
                                    setCookieForm={setCookieForm}
                                />
                            ))}
                        </div>
                        <div className='absolute top-0 right-0 translate-x-3 md:translate-x-6'>
                            <ScrollBar scrollRef={ref} style={{ height: '360px' }} />
                        </div>
                    </div>
                    <div className='absolute bottom-0 h-[80px] bg-gradient-to-t from-white w-full' />
                </div>
            </div>
            <div className='bottom-0 h-[95px] absolute right-0 p-3 md:pb-7 md:pr-10 flex items-end justify-end w-full'>
                <Button
                    buttonColor={Color.PURPLE}
                    isInverted
                    innerClasses='px-[54.5px] group-hover:px-[50.5px]'
                    onClick={submit}
                >
                    <h6>Save</h6>
                </Button>
            </div>
        </div>
    )
}

export default CookieModal
